// import { act } from 'react-dom/test-utils';
import Moment from 'moment';
import _ from "lodash"

const whichDayIsToday = () => {
  let d = new Date();
  let weekday = new Array(7);
  weekday[0] = 'sunday';
  weekday[1] = 'monday';
  weekday[2] = 'tuesday';
  weekday[3] = 'wednesday';
  weekday[4] = 'thursday';
  weekday[5] = 'friday';
  weekday[6] = 'saturday';
  return weekday[d.getDay()];
};

export function handleOpen(opentime, closetime, days) {
  const newOpenTime = Moment(opentime).tz('Australia/Sydney').format('LT');
  const newCloseTime = Moment(closetime).tz('Australia/Sydney').format('LT');
  let difference;
  var closeHours;
  var now = Moment().tz('Australia/Sydney');
  if (newCloseTime) {
    if (newCloseTime.includes('PM')) {
      var openHours, openMin;
      closeHours = parseInt(
        newCloseTime.substring(0, newCloseTime.indexOf(':'))
      );
      closeHours = closeHours === 12 ? closeHours : closeHours + 12;
      const closeMin = parseInt(
        newCloseTime.substring(
          newCloseTime.indexOf(':') + 1,
          newCloseTime.indexOf(':') + 3
        )
      );
      // const openHours = (parseInt(props.vendor.opentime.substring(0,props.vendor.opentime.indexOf(':')))+12)*60
      // const openMin   = parseInt(props.vendor.opentime.substring(props.vendor.opentime.indexOf(':')+1,props.vendor.opentime.indexOf(':')+3))
      if (newOpenTime.includes('AM')) {
        openHours = parseInt(
          newOpenTime.substring(0, newOpenTime.indexOf(':'))
        );
        openHours = openHours === 12 ? 0 : openHours;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openHours *= 60;
        openMin = parseInt(
          newOpenTime.substring(
            newOpenTime.indexOf(':') + 1,
            newOpenTime.indexOf(':') + 3
          )
        );
      } else {
        openHours = parseInt(
          newOpenTime.substring(0, newOpenTime.indexOf(':'))
        );
        openHours = openHours === 12 ? openHours : openHours + 12;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openHours *= 60;
        openMin = parseInt(
          newOpenTime.substring(
            newOpenTime.indexOf(':') + 1,
            newOpenTime.indexOf(':') + 3
          )
        );
      }
      closeHours *= 60;
      const currentHours = now.hours() * 60;
      const currentMinutes = now.minutes();

      const today = new Date().getDay().toString();
      if (days && days.indexOf(today) === -1) {
        difference = -1;
      } else if (openHours + openMin === closeHours + closeMin) {
        difference = 1;
      } else if (
        currentHours + currentMinutes > openHours + openMin &&
        currentHours + currentMinutes < closeHours + closeMin
      ) {
        difference = 1;
      } else {

        difference = -1;
      }
    } // if time in A.M.
    else {
      closeHours = parseInt(
        newCloseTime.substring(0, newCloseTime.indexOf(':'))
      );
      closeHours = closeHours === 12 ? 0 : closeHours;
      const closeMin = parseInt(
        newCloseTime.substring(
          newCloseTime.indexOf(':') + 1,
          newCloseTime.indexOf(':') + 3
        )
      );
      const currentHours = now.hours() * 60;
      const currentMinutes = now.minutes();
      if (newOpenTime.includes('AM')) {
        openHours = parseInt(
          newOpenTime.substring(0, newOpenTime.indexOf(':'))
        );
        openHours = openHours === 12 ? 0 : openHours;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openHours *= 60;
        openMin = parseInt(
          newOpenTime.substring(
            newOpenTime.indexOf(':') + 1,
            newOpenTime.indexOf(':') + 3
          )
        );
      } else {
        openHours = parseInt(
          newOpenTime.substring(0, newOpenTime.indexOf(':'))
        );
        openHours = openHours === 12 ? openHours : openHours + 12;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openMin = parseInt(
          newOpenTime.substring(
            newOpenTime.indexOf(':') + 1,
            newOpenTime.indexOf(':') + 3
          )
        );
      }

      closeHours *= 60;

      const today = new Date().getDay().toString();
      if (days && days.indexOf(today) === -1) {
        difference = -1;
      } else if (openHours + openMin === closeHours + closeMin) {
        difference = 1;
      } else if (
        currentHours + currentMinutes > openHours + openMin &&
        currentHours + currentMinutes < closeHours + closeMin
      ) {
        difference = 1;
      } else {
        difference = -1;
      }
    }
  }
  if (difference > 0) {
    return true;
  } else {
    return false;
  }
}

const initState = {
  superCategories: [],
  categories: [],
  subCategories: [],
  restaurantType: [],
  grocery_vendors: [],
  medicine_vendors: [],
  user: [],
  liquor_vendors: [],
  restaurant_vendors: [],
  food_vendors: [],
  cider_vendors: [],
  champagne_vendors: [],
  mixeddrinks_vendors: [],
  redwine_vendors: [],
  spirits_vendors: [],
  whitewine_vendors: [],
  pets_vendors: [],
  vegetables_vendors: [],
  laundry_vendors: [],
  meat_vendors: [],

  grocery_products: [],
  medicine_products: [],
  liquor_products: [],
  restaurant_products: [],
  food_products: [],
  cider_products: [],
  champagne_products: [],
  mixeddrinks_products: [],
  redwine_products: [],
  spirits_products: [],
  whitewine_products: [],
  pets_products: [],
  vegetables_products: [],
  laundry_products: [],
  meat_products: [],

  grocery_subcategory: [],
  medicine_subcategory: [],
  liquor_subcategory: [],
  restaurant_subcategory: [],
  food_subcategory: [],
  cider_subcategory: [],
  champagne_subcategory: [],
  mixeddrinks_subcategory: [],
  redwine_subcategory: [],
  spirits_subcategory: [],
  whitewine_subcategory: [],
  pets_subcategory: [],
  vegetables_subcategory: [],
  laundry_subcategory: [],
  meat_subcategory: [],

  individualProduct: null,
  auth: false,
  cart: [],
  promocode: '',
  zipcode: null,
  vendor_unable: false,
  success_message: '',
  error_message: '',
  email_loader: false,
  email_message: false,
  signupOpen: false,

  vendorBySuperCategory: [],
  products: [],
  menus: [],
  userDetails: {}
};

const userReducer = (state = initState, action) => {
  switch (action.type) {
    case 'USER_SIGNUP':
      return { ...state, success_message: action.payload.data };
    case 'USER_SIGNUP_ERROR':
      return { ...state, error_message: action.payload.error };
    case 'USER_UPDATE':
      return { ...state, success_message: action.payload.data };
    case 'USER_UPDATE_ERROR':
      return { ...state, error_message: action.payload.error };
    case 'UPDATE_PASSWORD':
      return { ...state, success_message: action.payload.data };
    case 'UPDATE_PASSWORD_ERROR':
      return { ...state, error_message: action.payload.error };
    case 'FORGET_PASSWORD':
      return { ...state, success_message: action.payload.data };
    case 'FORGET_PASSWORD_ERROR':
      return { ...state, error_message: action.payload.error };
    case 'USER_LOGIN':
      return { ...state, auth: true };
    case 'TOGGLE_SIGNUP':
      return { ...state, signupOpen: action.payload };
    case 'USER_LOGOUT':
      localStorage.removeItem('userLoginType')
      return { ...state, auth: false };
    case 'USER_LOGIN_ERROR':
      return state;

    case 'GET_SUPERCATEGORY_HOME':
      return { ...state, superCategories: action.payload.data };

    case 'GET_SUPERCATEGORY_HOME_ERROR':
      return state;
    case 'GET_CATEGORY_HOME':
      return { ...state, categories: action.payload.data };
    case 'GET_CATEGORY_HOME_ERROR':
      return state;
    case 'GET_ALL_RESTAURANT_TYPE':
      return { ...state, restaurantType: action.payload.data };
    case 'GET_ALL_RESTAURANT_TYPE_ERROR':
      return state;
    case 'GET_SUBCATEGORY_HOME':
      return { ...state, subCategories: action.payload.data };

    case 'GET_SUBCATEGORY_HOME_ERROR':
      return state;
    case 'GET_USER_DETAILS':
      return { ...state, userDetails: action.payload.data };

    case 'GET_VENDORS':
      return {
        ...state,
        vendor_unable: false,
        restaurant_vendors: action.payload.data
      };

    case 'GET_VENDORS2':
      if (action.payload.data === 'Currently not available in your area') {
        return {
          ...state,
          vendor_unable: 'Currently not available in your area'
        };
      } else {
        switch (action.payload.type) {
          case 'Grocery':
            return {
              ...state,
              vendor_unable: false,
              grocery_vendors: action.payload.data
            };
          case 'Medicine':
            return {
              ...state,
              vendor_unable: false,
              medicine_vendors: action.payload.data
            };
          case 'Liquor':
            return {
              ...state,
              vendor_unable: false,
              liquor_vendors: action.payload.data
            };
          case '8fe90210-2198-11eb-9bd5-25749c91958e':
            return {
              ...state,
              vendor_unable: false,
              restaurant_vendors: action.payload.data
            };
          case 'Food':
            return {
              ...state,
              vendor_unable: false,
              food_vendors: action.payload.data
            };
          case 'MixedDrinks':
            return {
              ...state,
              vendor_unable: false,
              mixeddrinks_vendors: action.payload.data
            };
          case 'Cider':
            return {
              ...state,
              vendor_unable: false,
              cider_vendors: action.payload.data
            };
          case 'WhiteWine':
            return {
              ...state,
              vendor_unable: false,
              whitewine_vendors: action.payload.data
            };
          case 'RedWine':
            return {
              ...state,
              vendor_unable: false,
              redwine_vendors: action.payload.data
            };
          case 'Champagne':
            return {
              ...state,
              vendor_unable: false,
              champagne_vendors: action.payload.data
            };
          case 'Spirits':
            return {
              ...state,
              vendor_unable: false,
              spirits_vendors: action.payload.data
            };
          case 'Pets':
            return {
              ...state,
              vendor_unable: false,
              pets_vendors: action.payload.data
            };
          case 'Vegetables':
            return {
              ...state,
              vendor_unable: false,
              vegetables_vendors: action.payload.data
            };
          case 'Laundry':
            return {
              ...state,
              vendor_unable: false,
              laundry_vendors: action.payload.data
            };
          case 'Meat':
            return {
              ...state,
              vendor_unable: false,
              meat_vendors: action.payload.data
            };
          default:
            return { ...state };
        }

        // return { ...state, vendors: action.payload.data, vendor_unable: false };
      }

    case 'GET_VENDORS_ERROR':
      return state;

    case 'GET_SUBCATEGORIES':
      switch (action.payload.type) {
        case 'Grocery':
          return { ...state, grocery_subcategory: action.payload.data };
        case 'Medicine':
          return { ...state, medicine_subcategory: action.payload.data };
        case 'Liquor':
          return { ...state, liquor_subcategory: action.payload.data };
        case 'Restaurant':
          return { ...state, restaurant_subcategory: action.payload.data };
        case 'Food':
          return { ...state, food_subcategory: action.payload.data };
        case 'MixedDrinks':
          return { ...state, mixeddrinks_subcategory: action.payload.data };
        case 'Cider':
          return { ...state, cider_subcategory: action.payload.data };
        case 'WhiteWine':
          return { ...state, whitewine_subcategory: action.payload.data };
        case 'RedWine':
          return { ...state, redwine_subcategory: action.payload.data };
        case 'Champagne':
          return { ...state, champagne_subcategory: action.payload.data };
        case 'Spirits':
          return { ...state, spirits_subcategory: action.payload.data };
        case 'Pets':
          return { ...state, pets_subcategory: action.payload.data };
        case 'Vegetables':
          return { ...state, vegetables_subcategory: action.payload.data };
        case 'Laundry':
          return { ...state, laundry_subcategory: action.payload.data };
        case 'Meat':
          return { ...state, meat_subcategory: action.payload.data };

        default:
          return { ...state };
      }
    case 'GET_SUBCATEGORIES_ERROR':
      return state;

    case 'GET_SUBCATEGORY_PRODUCTS':
      return { ...state, products: action.payload.data.product.items };

    case 'GET_SUBCATEGORY_PRODUCTS_ERROR':
      return state;

    case 'GET_CATEGORY_PRODUCTS':
      switch (action.payload.type) {
        case 'Grocery':
          return { ...state, grocery_products: action.payload.data };
        case 'Medicine':
          return { ...state, medicine_products: action.payload.data };
        case 'Liquor':
          return { ...state, liquor_products: action.payload.data };
        case 'Restaurant':
          return { ...state, restaurant_products: action.payload.data };
        case 'Food':
          return { ...state, food_products: action.payload.data };
        case 'MixedDrinks':
          return { ...state, mixeddrinks_products: action.payload.data };
        case 'Cider':
          return { ...state, cider_products: action.payload.data };
        case 'WhiteWine':
          return { ...state, whitewine_products: action.payload.data };
        case 'RedWine':
          return { ...state, redwine_products: action.payload.data };
        case 'Champagne':
          return { ...state, champagne_products: action.payload.data };
        case 'Spirits':
          return { ...state, spirits_products: action.payload.data };
        case 'Pets':
          return { ...state, pets_products: action.payload.data };
        case 'Vegetables':
          return { ...state, vegetables_products: action.payload.data };
        case 'Laundry':
          return { ...state, laundry_products: action.payload.data };
        case 'Meat':
          return { ...state, meat_products: action.payload.data };

        default:
          return { ...state };
      }
    case 'GET_PRODUCTS_ERROR':
      return state;

    case 'GET_INDIVIDUAL_PRODUCT':
      return state;

    case 'GET_INDIVIDUAL_PRODUCT_ERROR':
      return state;

    case 'ADD_TO_CART':
      return { ...state, cart: action.payload.data };
    case 'CLEAR_CART':
      return { ...state, cart: [], vendorWiseCart: [] };

    case 'ADD_TO_CART_ERROR':
      return state;

    case 'REMOVE_FROM_CART':
      const val = state.cart.filter((item) => item.pid !== action.payload.pid);
      return { ...state, cart: val };

    case 'REMOVE_FROM_CART_ERROR':
      return state;
    case 'GET_CART':
      var cartObj = []
      var cart_vendor_map = {}
      var data = action.payload.data
      var carts = [...data]
      if (data && data.length > 0) {
        data.forEach((data) => {
          if (cart_vendor_map[data.vendorId]) {
            let cartList = cart_vendor_map[data.vendorId]
            cartList.push(data)
            cart_vendor_map[data.vendorId] = cartList
          } else {
            let cartList = []
            cartList.push(data)
            cart_vendor_map[data.vendorId] = cartList
          }
        })
      }
      if (Object.keys(cart_vendor_map).length > 0) {
        Object.keys(cart_vendor_map).forEach((vendorId) => {
          var cartList = cart_vendor_map[vendorId]
          if (cartList.length > 0) {
            var vendor = cartList[0].vendor
            vendor.cart = cartList
            cartObj.push(vendor)
          }
        })
      }
      carts.map((c) => {
        delete c.vendor
        return c
      })
      return { ...state, cart: carts, vendorWiseCart: cartObj };
    case 'GET_CART_LOCAL':
      var cartObj = []
      var cart_vendor_map = {}
      var data = action.payload
      var carts = []
      var cartWithVendor = null
      if (data) {
        carts = [...data]
        if (data && data.length > 0) {
          data.forEach((data) => {
            if (cart_vendor_map[data.vendorId]) {
              let cartList = cart_vendor_map[data.vendorId]
              cartList.push(data)
              cart_vendor_map[data.vendorId] = cartList
            } else {
              let cartList = []
              cartList.push(data)
              cart_vendor_map[data.vendorId] = cartList
            }
          })
        }
        if (Object.keys(cart_vendor_map).length > 0) {
          Object.keys(cart_vendor_map).forEach((vendorId) => {
            var cartList = cart_vendor_map[vendorId]
            if (cartList.length > 0) {
              var vendor = cartList[0].vendor
              if (!vendor) {
                localStorage.setItem('my_carts', null)
                return { ...state, cart: [] };
              }
              vendor.cart = cartList
              cartObj.push(vendor)
            }
          })
        }
        cartWithVendor = _.cloneDeep(carts)
        carts.map((c) => {
          c.vendor = null
          return c
        })
      }
      return { ...state, cart: carts, cartWithVendor: cartWithVendor, vendorWiseCart: cartObj };
    case 'UPDATE_LOCAL_CART':
      var cartObj = []
      var cart_vendor_map = {}
      var data = action.payload.data
      var carts = []
      if (state.cartWithVendor && state.cartWithVendor.length > 0) {
        carts = [...state.cartWithVendor, action.payload]
      } else {
        carts = [action.payload]
      }
      if (carts && carts.length > 0) {
        carts.forEach((data) => {
          if (cart_vendor_map[data.vendorId]) {
            let cartList = cart_vendor_map[data.vendorId]
            cartList.push(data)
            cart_vendor_map[data.vendorId] = cartList
          } else {
            let cartList = []
            cartList.push(data)
            cart_vendor_map[data.vendorId] = cartList
          }
        })
      }
      if (Object.keys(cart_vendor_map).length > 0) {
        Object.keys(cart_vendor_map).forEach((vendorId) => {
          var cartList = cart_vendor_map[vendorId]
          if (cartList.length > 0) {
            var vendor = cartList[0].vendor
            if (vendor) {
              vendor.cart = cartList
              cartObj.push(vendor)
            }
          }
        })
      }
      const cartWithVendorArray = _.cloneDeep(carts)
      carts.map((c) => {
        c.vendor = null
        return c
      })
      return { ...state, cart: carts, cartWithVendor: cartWithVendorArray, vendorWiseCart: cartObj };
    case 'GET_CART_ERROR':
      return state;

    case 'GET_PROMOCODE':
      return { ...state, promocode: action.payload.data };

    case 'GET_PROMOCODE_ERROR':
      return { ...state.action.error };
    case 'GET_ZIPCODE':
      return { ...state, zipcode: action.payload };

    case 'GET_ZIPCODE_ERROR':
      return state;

    case 'GET_MY_ORDERS':
      return state;

    case 'GET_MY_ORDERS_ERROR':
      return state;

    case 'CHECKOUT':
      return state;

    case 'CHECKOUT_ERROR':
      return state;

    case 'ALERT_LOAD':
      return { ...state, alert: true };

    case 'ALERT_UNLOAD':
      return { ...state, alert: false };

    case 'SUCCESS_MESSAGE':
      return { ...state, success_message: action.payload };

    case 'OFFER_MESSAGE':
      return { ...state, offer_messages: action.payload.data };

    case 'CLEAR_SUCCESS_MESSAGE':
      return { ...state, success_message: '' };

    case 'ERROR_MESSAGE':
      return { ...state, error_message: action.payload };

    case 'API_PROGRESS':
      return { ...state, api_progress: action.payload };
    case 'GLOBAL_SEARCH':
      return { ...state, searchResult: action.payload.data };
    case 'CLEAR_ERROR_MESSAGE':
      return { ...state, error_message: '' };
    case 'ORDER_LIST':
      return { ...state, orders: action.payload };
    case 'TRANSACTION_LIST':
      return { ...state, transactions: action.payload };
    case 'PRODUCT_LOADING':
      return { ...state, productLoading: action.payload };
    case 'EMAIL_LOADING':
      return { ...state, email_loader: true };
    case 'EMAIL_UNLOADING':
      return { ...state, email_loader: false };
    case 'EMAIL_SUCCESS':
      return { ...state, email_message: action.payload };
    case 'VERIFY_COUPON_CODE':
      return { ...state, coupon: action.payload.data };
    case 'SET_VENDOR_BY_SUPER_CATEGORY':
      if (action.payload.data) {
        action.payload.data.map((vendor) => {
          const todayDay = whichDayIsToday()
          vendor.shopOpen = handleOpen(vendor?.timing[todayDay]?.openTime, vendor?.timing[todayDay]?.closeTime, vendor?.address?.days)
          return vendor;
        })
        var vendors = action.payload.data
        vendors.sort((v1, v2) => {
          if (v1.shopOpen && !v2.shopOpen) {
            return -1;
          }
          else if (!v1.shopOpen && v2.shopOpen) {
            return 1;
          } else {
            return v1.distance - v2.distance
          }
        })
        return { ...state, vendorBySuperCategory: vendors };
      }
      return { ...state, vendorBySuperCategory: action.payload.data };
    case 'VENDORS_LOADING':
      return { ...state, vendorLoading: action.payload };
    case 'SET_VENDOR_BY_ID':
      return { ...state, vendorById: action.payload.data };
    case 'SET_CATEGORY_AND_SUB_CATEGORY':
      return { ...state, categories: action.payload.data };
    case 'SET_VENDOR_PRODUCT':
      return { ...state, products: action.payload.data };
    case 'SET_VENDOR_MENU':
      return { ...state, menus: action.payload.data };
    default:
      return state;
  }
};

export default userReducer;
